// extracted by mini-css-extract-plugin
export default {"frame":"InterestSelected_frame__yZzDv","triangle":"InterestSelected_triangle__KBbk3"};